<div class="error_notificator_wrapper" [@showError]="animationState">
  <div class="error_notificator" *ngIf="lastErrorMessage$ | async">
    {{lastErrorMessage$ | async}}
  </div>
</div>

